export type AppRegion = "uk" | "ca";

export const REGION = process.env.REACT_APP_REGION as AppRegion;
export const isUK = REGION === "uk";
export const isCanada = REGION === "ca";

export const APP_VERSION = process.env.REACT_APP_VERSION as string;

export const APP_NAME = process.env.REACT_APP_APP_NAME as string;
export const PARAPASS_APP_NAME = process.env.REACT_APP_PARAPASS_APP_NAME as string;
export const PLUS_APP_NAME = process.env.REACT_APP_PLUS_APP_NAME as string;
export const BUNDLE_ID = process.env.REACT_APP_BUNDLE_ID as string;
export const AUTH_SERVER_URL = process.env.REACT_APP_AUTH_SERVER_URL as string;
export const PASSWORD_RESET_URL = process.env.REACT_APP_PASSWORD_RESET_URL as string;
export const PF_SERVER_URL = process.env.REACT_APP_PF_SERVER_URL as string;
export const PARAPASS_SERVER_URL = process.env.REACT_APP_PARAPASS_SERVER_URL as string;
export const PF_CONFIG_SERVER_URL = process.env.REACT_APP_PF_CONFIG_SERVER_URL as string;
export const GOOGLE_VERIFY_ENDPOINT = process.env.REACT_APP_GOOGLE_VERIFY_ENDPOINT as string;
export const CONFIG_BUCKET_BASE = (process.env.REACT_APP_CONFIG_BUCKET_BASE as string).replace(/\/$/, "");
export const PLUS_DEEPLINK_URL = process.env.REACT_APP_PLUS_DEEPLINK_URL as string;
export const PARAPASS_DEEPLINK_URL = process.env.REACT_APP_PARAPASS_DEEPLINK_URL as string;
export const HCPC_URL = process.env.REACT_APP_HCPC_URL as string;
export const FEEDBACK_FORM_URL = process.env.REACT_APP_FEEDBACK_FORM_URL as string;
export const TERMS_AND_CONDITIONS_URL = process.env.REACT_APP_TERMS_AND_CONDITIONS_URL as string;
export const CLASS_APPS_URL = process.env.REACT_APP_CLASS_APPS_URL as string;
export const CLASS_PARAFOLIO_WEB_SUBSCRIPTION_URL = process.env
  .REACT_APP_CLASS_PARAFOLIO_WEB_SUBSCRIPTION_URL as string;
export const CLASS_PARAFOLIO_URL = process.env.REACT_APP_CLASS_PARAFOLIO_URL as string;
export const CLASS_TERMS_URL = process.env.REACT_APP_CLASS_TERMS_URL as string;
export const PF_FAQ_URL = process.env.REACT_APP_PF_FAQ_URL as string;
export const PF_FEATURES_URL = process.env.REACT_APP_PF_FEATURES_URL as string;
export const APPLE_PRODUCT_IDS = (process.env.REACT_APP_APPLE_PRODUCT_IDS as string).split(",");
export const GOOGLE_PRODUCT_IDS = (process.env.REACT_APP_GOOGLE_PRODUCT_IDS as string).split(",");
export const GOOGLE_PLAY_MANAGE_SUBSCRIPTIONS_URL = process.env
  .REACT_APP_GOOGLE_PLAY_MANAGE_SUBSCRIPTIONS_URL as string;
export const GOOGLE_PLAY_APP_URL = process.env.REACT_APP_GOOGLE_PLAY_APP_URL as string;
export const APPLE_APP_URL = process.env.REACT_APP_APPLE_APP_URL as string;
export const WEB_HOSTS = (process.env.REACT_APP_WEB_HOSTS as string).split(",");
export const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN as string;

export const firebaseConfig = {
  production: false,
  firebaseConfig: {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY as string,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN as string,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID as string,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET as string,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID as string,
    appId: process.env.REACT_APP_FIREBASE_APP_ID as string,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID as string,
  },
};
